var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Button',{class:[
    _vm.$style.wrapper,
    ( _obj = {}, _obj[_vm.$style.isSelected] = _vm.isSelected, _obj ),
    _vm.$attrs.class,
    _vm.$style[_vm.listTheme] ],attrs:{"child-class":[_vm.$attrs['child-class'], _vm.$style.childClass],"appearance":"clean"},on:{"click":function (event) { return _vm.$emit('selected', event); }},scopedSlots:_vm._u([{key:"leftIcon",fn:function(){return [_vm._t("leftIcon")]},proxy:true},{key:"rightIcon",fn:function(){return [_vm._t("rightIcon")]},proxy:true}],null,true)},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }